import classNames from "classnames";

/**
 * SectionContainer represents a section of a page, and isn't supposed to do much other than supply classes
 * to be used for page layout / css grid
 */
export const SectionContainer = (props) => {
    const containerClasses = classNames(
        "pageContentWrap",
        "sectionContainer",
        props.className
    );

    return (
        <section
            className={containerClasses}
            data-testid="section-container"
            data-cy="section-container"
        >
            <div
                className="sectionContainer-wrapper"
                data-testid="section-container-wrapper"
            >
                {props.children}
            </div>
        </section>
    );
};
